const getUserData = ()=>{
    // eslint-disable-next-line no-restricted-globals 
    let userData =  localStorage.getItem('userData')
    return userData  = userData ? JSON.parse(userData) :""
}
export {getUserData}